import { SaveButton as RaSaveButton, SaveButtonProps } from "react-admin";

export default function EdmSaveButton(props: SaveButtonProps) {
  const { icon = <></>, ...buttonProps } = props;

  return <RaSaveButton icon={icon} {...buttonProps} />;
}
